import { Box, Button, Slide, useScrollTrigger } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useStyles } from "../quoteDetail.styles";

export const BookNowButton = ({ quoteId }: { quoteId?: string }) => {
  const classes = useStyles();
  const trigger = useScrollTrigger({
    target: window ? window : undefined,
    disableHysteresis: true,
    threshold: 100
  });
  return (
    <Slide direction="up" in={trigger}>
      <Box
        position={"fixed"}
        bottom={0}
        width={"100%"}
        py={"24px"}
        px={"36px"}
        bgcolor={"#fff"}
        boxShadow={"0 -2px 4px 0 rgba(0, 0, 0, 0.1)"}
        zIndex={99}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {quoteId ? (
          <Button
            component={Link}
            to={`/checkout/${quoteId}`}
            variant="contained"
            color="secondary"
            className={classes.btnBookNowMobile}
          >
            Book Now
          </Button>
        ) : (
          <Button
            variant="contained"
            color="secondary"
            className={classes.btnBookNow}
            href="https://swyftenergy4.schedulista.com/"
            target="_blank"
          >
            Book a Call
          </Button>
        )}
      </Box>
    </Slide>
  );
};
